import React from 'react';
import cn from 'classnames';
import originalStyles from '../../styles/SitemapWrapper.module.scss';
import { extractStyle } from '../../styles/styles-extract-util';
import { SitemapContent } from './SitemapContent';
import { SitemapBottom } from './SitemapBottom';

export const SitemapWrapper: React.FC = () => {
  const styles = extractStyle(originalStyles);
  return (
    <div className={cn(styles.sitemapWrapper, 'base-grid')}>
      <div className={styles.sitemap}>
        <SitemapContent />
        <SitemapBottom />
      </div>
    </div>
  );
};